
/* Home author link: measured destination after lazy content settles; no repeated automatic scrolling. */
(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-sf-home-about]');
    if (!link) return;
    const target = document.querySelector('.sf-home #ueber-mich');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    history.pushState(null, '', '#ueber-mich');
    const header = document.querySelector('[data-sf-header]');
    const offset = Math.max(0, header?.getBoundingClientRect().height || 0) + 18;
    const host = document.querySelector('.page-wrapper');
    const internal = host && host.scrollHeight > host.clientHeight + 3 && /^(auto|scroll)$/.test(getComputedStyle(host).overflowY);
    const top = internal ? target.getBoundingClientRect().top - host.getBoundingClientRect().top + host.scrollTop - offset : target.getBoundingClientRect().top + window.scrollY - offset;
    (internal ? host : window).scrollTo({top:Math.max(0,top),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }, true);
})();

/* Translate isolated platform-provided cookie link labels. */
(() => { const fix=()=>document.querySelectorAll('button,a').forEach(el=>{if(el.children.length===0 && /^\\s*Cookie Preferences\\s*$/i.test(el.textContent||''))el.textContent='Cookie-Einstellungen';});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix,{once:true});else fix();})();

/* Wheel input in the enlarged gallery is handled by the single gesture recognizer in sherif-qa-0311.js. */
/* Avoid duplicate privacy page headings only when adjacent title and first content heading are identical. */
(() => {
 const fix=()=>{
  if(!/datenschutz|privacy-policy/.test(location.pathname))return;
  const title=document.querySelector('.shopify-policy__title h1,.section-content-wrapper h1');
  const body=document.querySelector('.shopify-policy__body,.page-content');
  const heading=body?.querySelector('h1,h2');
  if(title&&heading&&title!==heading&&title.textContent.trim().toLowerCase()===heading.textContent.trim().toLowerCase())heading.hidden=true;
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix,{once:true});else fix();
})();
